<h2 class="text-center mb-2">Select Learnership</h2>
<div class="py-2 px-4">
  <div
    class="card shadow w-100 mb-2 p-3"
    *ngFor="let learnership of initialLearnerships"
  >
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div>
          {{ learnership.learnershipName }}
        </div>
        <div
          class="ms-3 py-0 me-0 my-0 px-1 alert"
          [ngClass]="{
            'text-success alert-success': learnership.current,
            'text-danger alert-danger': !learnership.current
          }"
        >
          <small>{{ learnership.current ? 'Current' : 'Past' }}</small>
        </div>
      </div>
      <button
        *ngIf="
          learnershipSelectorService.currentStudentLearnership
            ?.studentLearnershipId !== learnership.studentLearnershipId
        "
        class="btn btn-sm btn-primary"
        (click)="learnershipSelected(learnership)"
      >
        Select
      </button>
    </div>
  </div>
</div>
